<template>
  <div class="order-container">
    <Header :title="headerTitle"></Header>
    <div class="tabs-container main">  
      <van-tabs v-model="orderStatus" sticky>
        <van-tab
          v-for="tab in tabList"
          :key="tab.key"
          :name="tab.key"
          :title="tab.name"
        >
        </van-tab>
        <div class="card">
    <div class="tab1-div" v-if="dataQ =='1'">
      <div class="tab1-div-img">
        <img src="@/assets/imgs/zhijiandan.png" />
        <p>扫描质检标签码</p>
        <div class="card-btn mar-top-200">
           <van-button class="btn" @click="getToScan()">扫码</van-button>
        </div>     
      </div>    
    </div>
    <div class="tab2-div" v-if="dataQ =='2'">
      <van-cell-group>
        <van-field
          label="产品名称"
          label-width="100"
          v-model="form.commodityName"
          placeholder="请输入产品名称"
        />
        <van-field
          label="生产企业编号"
          label-width="100"
          v-model="form.manufacturer"
          placeholder="请输入生产企业编号"
        />
        <van-field
          label="规格牌号"
          label-width="100"
          v-model="form.spec"
          placeholder="请输入规格牌号"
        />
        <van-field
          label="产品批(罐)号"
          label-width="100"
          v-model="form.batchNo"
          placeholder="请输入产品批(罐)号"
        />
      </van-cell-group>
      <div class="card-btn mar-top-200">
          <van-button class="btn" @click="chaxun()">查询</van-button>
      </div>     
    </div>

  </div>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header';
import { getScan } from "@/request/flutterBrid";
// import transactionApi from "@/request/transactionApi";
import axios from "axios";
export default {
  name: "QualityInspectionForm",
  components: {
    Header
  },
  data() {
    return {
      orderStatus: "1",
      dataQ: "1",
      headerTitle: "质检单查询",
      tabList: [
        {
          key: "1",
          name: "扫码查询",
        },
        {
          key: "2",
          name: "输入查询",
        }    
      ],
      form: {
        commodityName: "",
        manufacturer: "",
        batchNo: "",
        spec: ""
      },
      fileName: "",
      fileAddress: "",
    };
  },
  computed: {
  },
  watch: { 
    //TAB切换
    orderStatus(val) {
     this.dataQ = val;
    },
  },
  created() {
    // this.getBrandList();
  },
  methods: {
    getToScan() {
      // this.$toast("result00000");
      getScan((result) => {
        console.log(result);
        // this.$toast(result);
        let data2 = result.split('batchid=');
        let arr = [];
        arr = data2[1].split(",");
        console.log("arr", arr);
        this.form.manufacturer =arr[0];
        // this.form.commodityName =arr[1];
        this.form.spec =arr[1];
        this.form.batchNo =arr[2];
        this.chaxun();      
                  
      });

    },
    chaxun() {
       let params = Object.assign({}, this.form);
       delete params.commodityName;
       axios.post('https://lms.chem.petrochina.com.cn/api/quality/integrate/getQcFileInfo', 
        params
      ) .then((res) => {
        console.log(5555,res);
        if(res.data.code === 200) {
           this.$router.push("/qualityInspectionDetails?fileAddress="+ res.data.data.attachmentAddress);
        } else {
          this.$toast({
                  type: "fail",
                  message: res.data.msg,
                  duration: 1500,
                });
        }
      })
      // transactionApi.getQualityCert(params).then((res) => {
      //       if (res.returnCode == "0") {
      //          if (!res.result.fileName) {
      //             this.$toast('查询不存在');
      //           } else {
      //             this.fileName = res.result.fileName;
      //             this.fileAddress = res.result.fileAddress;
      //             this.$router.push("/qualityInspectionDetails?fileAddress="+ this.fileAddress+"&fileName=" + this.fileName);
                  
      //           }
      //         } else {
      //           this.$toast({
      //             type: "fail",
      //             message: res.returnMessage,
      //             duration: 1500,
      //           });
      //         }
      //     });
    },
 
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';
.order-container >>> .van-tabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.order-container >>> .van-tabs__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.order-container >>> .van-tabs .van-tabs__wrap {
  height: 88px;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab {
  font-size: 32px;
  line-height: 45px;
  color: #333333;
}

.order-container >>> .van-tabs .van-tabs__wrap .van-tab--active {
  // font-size: 36px;
  color: #E12020;
}

.order-container >>> .van-popup {
  height: 100%;
  width: 576px;
}

.order-container >>> .van-empty__image {
  width: 360px;
  height: 360px;
}

.order-container >>> .van-empty__description {
  font-size: 0.32rem;
  line-height: 0.38rem;
}
.order-container >>> .van-tabs__wrap{
  border-bottom: 4px solid #eeeeee;
}

.order-container {
  display: flex;
  flex-direction: column;
  height: 100%;

  .tabs-container {
    flex: 1;
    display: flex;
    overflow: hidden;
    background: #ffffff;
  }
}

.tab1-div-img {
  text-align: center;
  margin-top: 60px;
  p {
    margin-top: 20px;
  }
  
}
.mar-top-200 {
  margin-top: 200px;
}
.card-btn {
    height: 120px;
    text-align: center;
    .btn {
      min-width: 80%;
      height: 72px;
      background: $gradientColor;
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
}
.tab2-div >>> .van-cell {
  height: 80px;
  line-height: 80px;
  font-size: 28px;
}
.card {
  background: #ffffff;
  padding: 12px 24px;
  font-size: 26px;

  .card-header, .card-total, .card-info {
    padding: 12px 0;
  }

  .card-info, .card-total {
    color: #666666;
  }

  .info {
    line-height: 61px;

    .info-title {
      display: inline-block;
      min-width: 80px;
      text-align: justify;
      text-align-last: justify;
    }

    .info-value {
      margin-left: 16px;
    }

    .status {
      color: #3A70CC;
    }
  }

  .color-red {
    color: #E12020;
  }

  .large {
    font-size: 36px;
  }
}
</style>